<template>
  <div class="ranking">
    <div class="header">
      <div class="header_section">
        <router-link to="/profile" class="header_element header_icone mobile">
          <!--          <font-awesome-icon color="#00d7fe"  :icon="['fas','arrow-left']"/>-->
          <font-awesome-icon color="#00d7fe" class="reverse mobile" icon="angle-right"/>
        </router-link>
        <h1 class="header_element">Classements</h1>
      </div>
    </div>

    <div class="content_container">

      <div class="user_ranking">
        <span>{{ user.rank }}</span>
        <span>{{ user.name }}</span>
        <div style="display: flex;font-size:12px;">{{ user.challenges }} <span class="icon icon-trophy icon-xs"
                                                                               style="left:5px;"></span></div>
        <span>{{ user.score }}</span>
      </div>


      <div class="event_section">

        <div class="general-rank event" data-ranking="general" @click="openRanking">
          <img width="100%" src="img/logo.png" alt="">
          <span>GENERAL</span>

        </div>
        <div class="register-rank event" data-ranking="client" @click="openRanking"
             v-if="user.user_type==='Client'||user.user_type==='Admin'">
          <img width="100%" src="img/logo.png" alt="">

          <span>CLIENT</span>

        </div>
        <div class="register-rank event" data-ranking="admin" @click="openRanking" v-if="user.user_type==='Admin'">
          <img width="100%" src="img/logo.png" alt="">

          <span>ANIMHEAD TEAM</span>

        </div>

        <div class="event" v-for="(event,index) in events" @click="openRanking(event,'event')">
          <img width="100%" src="img/logo.png" alt="">
          <span>{{ event.event_name }}</span>
        </div>

        <template v-for="(eventgame,index) in eventgames">
          <div class="event games" v-for="(game,index) in eventgame.games" @click="openRanking(game,'eventgame')">
            <img width="100%" src="/img/logo.png" alt="">
            <span>{{ game.name }}</span>
            <span class="event-tag">{{ eventgame.order }} </span>
          </div>
        </template>


        <div class="event games" v-for="(game,index) in games" @click="openRanking(game,'game')">
          <img width="100%" src="/img/logo.png" alt="">
          <span>{{ game.name }}</span>
        </div>

      </div>
    </div>


    <div class="event-popup" :class="{'active':event}">
      <transition name="bounce" enter-active-class="animated bounceIn" leave-active-class="animated bounceOut">
        <div class="event-container" v-if="event">
          <div class="title">
            <img :src="event.id_client?event.id_client.logo:'img/logo.png'" alt="">
            <h2>Classement <span>{{ event.event_name }}</span></h2>
          </div>
          <div class="ranking_container">
            <div class="user_rank" v-for="rank in ranking">
              <img width="20%" :src="rank.id_user?rank.id_user.avatar:rank.avatar" alt="">
              <span>{{ rank.id_user ? rank.id_user.name : rank.name }}</span>
              <span>{{ rank.pts ? rank.pts : rank.score }}</span>
            </div>
          </div>
          <div class="close" @click="closeRanking">Fermer</div>
        </div>
      </transition>
    </div>


  </div>
</template>
<script>
import {store} from '../store/store';
import {mapState, mapActions} from "vuex";

export default {
  name: 'Ranking',
  data() {
    return {
      rankings: null,
      user: store.getters.getUser,
      event: null,
      ranking: null,
      events: null,
      eventgames: null,
      games: null
    }
  },
  methods: {
    ...mapActions([
      'getRanking',
      'getUserEvent',
      'getUsersRanking',
      'getRegisterRanking'

    ]),
    openRanking(event, type = null) {
      this.event = event

      if (event.currentTarget.dataset.ranking) {
        let ranking_S = event.currentTarget.dataset.ranking

        this.getUsersRanking(ranking_S).then(res => {
          this.ranking = res
        })

      } else {


        this.getRanking(event.id).then(res => {
          this.ranking = res
        })
      }


    },
    closeRanking() {
      this.event = null
    },

  },
  computed: {
    ...mapState([
      "masks",
      "logged"
    ])
  },
  mounted() {
    !localStorage.getItem('user') && this.$router.push({name: "login", params: {type: 'connexion'}});
    this.getUserEvent().then(res => {
      this.events = res;
      this.eventgames = res.map(el => {
        el.games.forEach(ele => {
          if (this.games === null) {
            this.games = []
            this.games.push(ele)
          }
          if (!this.games.find(element => element.id === ele.id)) {
            this.games.push(ele)
          }
        })
        return {order: el.event_name, games: el.games}
      })

    })
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

.header {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}

.ranking {
  z-index: 1;
  background: #fff;
  margin-bottom: 40px;
}

.header_icone {
  font-size: 30px;
  /*line-height: 80px;*/
}

.header_section {
  display: flex;
  align-items: center;
}

.header_section:first-child {
  justify-content: center;
  width: 100%;
}

.header_section:first-child .header_element:first-child {
  position: absolute;
  left: 10px;
}

.header_element {
  margin: 0 0 0 10px;
  color: #00d7fe;
  text-decoration: none;
}

h1.header_element {
  font-size: 3em;
  /*border-bottom:4px solid #00d7fe;*/
  padding: 0;
  position: relative;
}


.content_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.user_ranking {
  display: flex;
  justify-content: space-between;
  width: 30%;
  border: 1px solid var(--main-color);
  border-radius: 5px;
  padding: 5px 10px;
}

.content_section {
  /*display: flex;*/
  /*flex-direction: column;*/
  /*margin-top: 30px;*/
}

.event_section {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
}

.event {
  display: flex;
  flex-direction: column;
  border: 2px solid var(--main-color);
  border-radius: 5px;
  position: relative;
  width: 23%;
  margin: 10px;
  padding: 10px;
}

.event:hover {
  cursor: pointer;
}

.event img {
  margin: 0 0 20px auto;
}

.event span {
  text-align: center;
  padding: 5px 0;
  width: 100%;
  color: #fff;
  background: var(--main-color);
  position: absolute;
  bottom: 0;
  left: 0;
}

.event span.event-tag {
  top: -2px;
  left: -2px;
  z-index: 2;
  border-radius: 5px 5px 0 0;
  height: min-content;
  border: 1px solid var(--main-color);
  width: calc(100% + 2px);
}

.event.games {
  border-color: #ec5b53;
}

.event.games span:not(.event-tag) {
  z-index: 1;
  background: #ec5b53;
}

.event-popup {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  margin: 0;
  z-index: 3;
  background: var(--main-dark-color);
  display: none;
}

.event-popup.active {
  display: flex;
}

.event-container {
  margin: auto;
  background: #fff;
  border-radius: 10px;
  /*border:2px solid #00d6ff;*/
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 20px;
  z-index: 10;
  min-height: 60vh;
  min-width: 60%;
}

.event-container .title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: var(--main-title-font);
  color: var(--main-color);
  letter-spacing: 5px;
  font-weight: 200;
}

.event-container .title img {
  width: 100px;
}

.event-container .title h2 {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  justify-content: center;
  margin: 5px;
  width: 50%;
}

.event-container .title h2 span {
  font-size: 1em;
}

.event-container .ranking_container {
  width: 100%;
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  height: 100%;
}

.event-container .ranking_container .user_rank {
  width: 50%;
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  align-items: center;
  border: 1px solid var(--main-color-darkness);
  border-radius: 10px;
  margin: 10px;
  background: rgba(255, 255, 255, 0.6);
  position: relative;
  min-height: 45px;
}

.event-container .ranking_container .user_rank img {
  border-radius: 50%;
}

.event-container .ranking_container .user_rank:nth-child(1):after {
  display: block;
  position: absolute;
  content: "";
  top: -10px;
  left: -40px;
  width: calc(100% + 80px);
  height: calc(100% + 20px);
  background: rgba(244, 228, 44, 0.55);
  border-radius: 10px;
  z-index: -1;
}

.event-container .ranking_container .user_rank:nth-child(2):after {
  display: block;
  position: absolute;
  content: "";
  top: -10px;
  left: -40px;
  width: calc(100% + 80px);
  height: calc(100% + 20px);
  background: rgba(192, 192, 192, 0.55);
  border-radius: 10px;
  z-index: -1;
}

.event-container .ranking_container .user_rank:nth-child(3):after {
  display: block;
  position: absolute;
  content: "";
  top: -10px;
  left: -40px;
  width: calc(100% + 80px);
  height: calc(100% + 20px);
  background: rgba(196, 156, 72, 0.55);
  border-radius: 10px;
  z-index: -1;
}


.event-container .close {
  position: absolute;
  bottom: -20px;
  margin: auto;
  color: #fff;
  background: var(--main-red-color);
  border-radius: 5px;
  padding: 5px 20px;
}

.close, .own {
  transition: .3s;
}

.close:hover, .own:hover {
  cursor: pointer;
  filter: brightness(80%);

}


.empty-case {
  display: flex;
}

.empty-case > * {
  color: #bebebe;
  font-family: Poppins;
  padding: 20px;
  margin: auto;
}


.content_element {
  color: white;
  border-radius: 20px;
  background-color: #00d6ff;
  height: 70px;
  display: flex;
  width: 90%;
  margin: 10px auto;
  justify-content: space-between;
}

a {
  text-decoration: none;
}

a.addinsta {
  color: #00a6d9;
}

@media screen and (max-width: 750px) {

  .event {
    width: 45%;
  }

  .user_ranking {
    width: 60%;
  }

  .event_section {
    margin-top: 20px;
  }
}
</style>
